<!-- 列表 -->
<SiteDiary-List *ngIf="!displayTemplate" (emitPermission)="emitPermission($event)" (listItemButton)="listItemClick()" [displayTemplate]="displayTemplate" [currentPage]="currentPage" [oldAction]="action"></SiteDiary-List>
<!-- 点击列表edit按钮的页面 -->
<SiteDiary-Details *ngIf="displayTemplate=='edit' || displayTemplate == 'copy'" [siteDiaryPermission]="siteDiaryPermission" (submitButton)="listItemClick()"></SiteDiary-Details>
